import type { GroupField } from '@prismicio/client';
import { Dispatch, SetStateAction } from 'react';
import type {
  BlogArticleDocumentDataContentItem,
  BlogArticleDocumentDataSocialMediaLinksItem,
  Simplify,
} from '../../../../../../../../prismicio-types';
import { Content } from './Content/Content';

import styles from './articleContents.module.scss';
import { Media } from './Media/Media';

interface ArticleContentProps {
  content: GroupField<Simplify<BlogArticleDocumentDataContentItem>>;
  media: GroupField<Simplify<BlogArticleDocumentDataSocialMediaLinksItem>>;
  setOffsetElement: Dispatch<SetStateAction<string>>;
}

export const ArticleContent = ({
  content,
  media,
  setOffsetElement,
}: ArticleContentProps) => {
  return (
    <article className={styles.article}>
      {content.map((item, index) => (
        <Content
          content={item}
          key={`${item.type}${index}`}
          setOffsetElement={setOffsetElement}
        />
      ))}
      <div className={styles.media}>
        <span className={styles.media_title}>Share</span>
        <ul className={styles.media_list}>
          {media.map((item, index) => (
            <Media media={item} key={`${item.icon} ${index}`} />
          ))}
        </ul>
      </div>
    </article>
  );
};
